import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

export const SITE_URL = "https://hhcv.co.uk";
const SITE_NAME = "Hydronic Heating Controls and Valves";

export const COLLECTION_NAMES = {
  "myson-trvs": "Thermostatic Radiator Valves",
  "myson-manual-radiator-valves": "Manual Radiator Valves",
  "myson-thermostats": "Electronic Controls",
  "myson-mpe-valves": "Motorised Valves",
  "kickspace-grills": "Myson Fan Convectors",
  "bleed-vents": "Accessories",
};
const DEFAULT_TITLE = "Hydronic Heating Controls and Valves | Premium Heating Spares — UK";
const DEFAULT_DESC =
  "Premium heating controls & spares for UK homeowners and installers. Genuine Myson TRVs, thermostats, MPE valves, bleed vents & kickspace grills with free tracked UK delivery (Royal Mail Tracked 48).";

export const Seo = ({ title, description, image, noindex = false, jsonLd }) => {
  const { pathname } = useLocation();
  const canonical = `${SITE_URL}${pathname === "/" ? "" : pathname}`;
  const desc = (description || DEFAULT_DESC).slice(0, 160);
  const fullTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <meta property="og:site_name" content="Hydronic Heating Controls & Valves" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      {image && <meta name="twitter:image" content={image} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default Seo;
